module.exports = __webpack_public_path__ + "static/media/logo-plaston-white.dda4810d.svg";